<template>
	<div class="home">
		<Header ref="header" :type='headType'></Header>
		<BanIn url="image003">
			<template v-slot:text>
				<h2 class="inTit f48 wow fadeInLeft">经典案例</h2>
				<div class="inDes f24 wow fadeInRight">
					<p>提供仓储、装卸、简单包装、配送、库存管理、信息处理、咨询等“一站式”综合物流服务</p>
				</div>
			</template>
		</BanIn>
        <div class="mainBg">
            <div class="breadBg">
                <div class="wrap">
					<div class="breadBox flex align-center justify-between">
						<ul class="breadNav">
							<li><router-link to="/">首页</router-link></li>
							<li><router-link to="/case">经典案例</router-link></li>
							<li class="active">经典案例详情</li>
						</ul>
						<div class="from">信息来源：<span>春溢通物流</span></div>
					</div>
                </div>
            </div>
			<div class="caseBg">
				<div class="wrap">
					<h1 class="caseName f30 color3">{{info.title}}</h1>
					<div class="caseLine"></div>
					<div class="caseText f18 color6 editor">
						<!-- <div class="caseImg" v-if="info.image"><img :src="info.image" alt=""></div> -->
						<div class="caseCon" v-html="info.content"></div>
					</div>
					<h2 class="caseH2 f24 color0" v-if="info.file_list != null && info.file_list.length">相关附件</h2>
					<ul class="annexList f18 color3" v-if="info.file_list != null">
						<li v-for="(item, index) in info.file_list" :key="index"><span class="ellipsis">{{item.name}}</span><router-link :to="item.url">在线预览</router-link></li>
					</ul>
					<div class="casePage f18 color6">
						<p class="ellipsis" v-if=" prev.id == ''">上一个：{{prev.title}}</p>
						<p class="ellipsis" v-else><router-link :to="'caseDetail?id='+prev.id">上一个：{{prev.title}}</router-link></p>
						<p class="ellipsis" v-if="next.id == ''">下一个：{{next.title}}</p>
						<p class="ellipsis" v-else><router-link :to="'caseDetail?id='+next.id">下一个：{{next.title}}</router-link></p>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>
<script>
import Header from '@/components/Header.vue'
import BanIn from '@/components/BanIn.vue'
import Footer from '@/components/Footer.vue'
import { WOW } from 'wowjs'
import home from '../api/home'
// import home from '@/api/home'
export default {
    name: 'caseDetail',
    components: {
        Header,
        BanIn,
        Footer
    },
    data() {
        return {
            headType:3,
            id:"",
			info:{},
			prev:{},
			next:{}
        }
    },
    watch: {
        '$route' () {
            this.getData(this.$route.query.id)
        }
    },
    mounted () {
        this.$nextTick(()=>{
            new WOW({ boxClass:"wow",animateClass:"animated",offset:5,mobile:true,live:false,resetAnimation:true }).init()
        });
        this.id = this.$route.query.id;
		this.getData(this.id);
    },
    methods: {
        async getData(id){
            this.id = id;
			await home.caseInfo({id:this.id}).then((res)=>{
				if (res.code === 1) {
					this.info = res.data
					this.prev = this.info?.prev
					this.next = this.info?.next
				} else {
					this.$toast(res.msg)
				}
			});
        },
    },
    destroyed(){
        
    }
}
</script>

<style lang="scss" scoped>
	@import '@/assets/css/case.scss';
</style>